export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <img 
                src="https://static.readdy.ai/image/207177310b9abd83a3c3d5d478fef01c/d54c14dc5362ebf66a05e3e8acf94ea7.png" 
                alt="Infraestructuras Holaasks" 
                className="h-14 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Soluciones digitales innovadoras para optimizar tu negocio en la nube.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-teal-500 rounded-lg transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-teal-500 rounded-lg transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-teal-500 rounded-lg transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-teal-500 rounded-lg transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Servicios</h4>
            <ul className="space-y-3">
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Gestión de Afiliados
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Administración de Suscripciones
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Interacción con Clientes
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Infraestructura Cloud
                </a>
              </li>
              <li>
                <a href="#servicios" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Analytics Avanzado
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Empresa</h4>
            <ul className="space-y-3">
              <li>
                <a href="#nosotros" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Sobre Nosotros
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Casos de Éxito
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Carreras
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Recursos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Documentación
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  API Reference
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Centro de Ayuda
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Estado del Sistema
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Términos y Condiciones
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 Infraestructura Ho Laasks. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                Términos de Servicio
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}